import { DateTime } from 'luxon';
import { translate, TArgs } from '../../utils/helpers';
import { DatePickerType, DateTimeMutation, FormatDateSelectLabel, DateTimeToString } from './types';

export const dateNames: Record<DatePickerType, TArgs> = {
    day: translate('Day'),
    week: translate('Week'),
    month: translate('Month'),
    year: translate('Year'),
};

const endOfMap: Record<DatePickerType, DateTimeMutation> = {
    day: date => date.startOf('day'),
    week: date => date.minus({ week: 1, day: -1, conversionAccuracy: 'longterm' }).startOf('day'),
    month: date => date.minus({ month: 1, conversionAccuracy: 'longterm' }).startOf('day'),
    year: date => date.minus({ year: 1, conversionAccuracy: 'longterm' }).startOf('day'),
};

export const getEndDate = (start: DateTime | null) => {
    if(!start){
        return null;
    }

    return start.endOf('day');
};

export const getStartDate = (start: DateTime | null, type: DatePickerType) => {
    if(!start){
        return null;
    }

    const dateStartFunction = endOfMap[type];
    return dateStartFunction(start);
};


const formatDateSelectLabelMap: Record<DatePickerType, DateTimeToString> = {
    day: date => `${date.toFormat('MMM d')}`,
    week: date => `${date.toFormat('MMM d')} - ${date.minus({ week: 1, day: -1, conversionAccuracy: 'longterm' }).toFormat('MMM d')}`,
    month: date => `${date.toFormat('MMM d')} - ${date.minus({ month: 1, conversionAccuracy: 'longterm' }).toFormat('MMM d')}`,
    year: date => `${date.minus({ year: 1, conversionAccuracy: 'longterm' }).toFormat('M.d.yy')} - ${date.toFormat('yy')}`,
};

export const formatDateSelectLabel = (type: DatePickerType): FormatDateSelectLabel  => {
    const labelFormatFunction = formatDateSelectLabelMap[type];

    return (date, invalidLabel) => {
        if(date === null){
            return '';
        }
        if(date){
            return labelFormatFunction(date);
        }
        return invalidLabel;
    };
};